import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { OwnerDetailRequestBody, OwnerDetailResponse } from "./types";

export class OwnerDetailAPI extends BaseAPI<
    OwnerDetailRequestBody,
    OwnerDetailResponse
> {
    protected route = ApiRoutes.owner.detail;
    protected method = RequestMethod.GET;
    protected params = ["id"];
}
